import { gql } from "@apollo/client";

export const createTargetRate = gql`
  mutation CreateTargetRates($targetId: ID!, $rates: [TargetRateInput!]!) {
    createTargetRates(target_id: $targetId, rates: $rates)
  }
`;

export const updateTargetRate = gql`
  mutation UpdateTargetRate($targetRateId: ID!, $rate: TargetRateInput!) {
    updateTargetRate(target_rate_id: $targetRateId, rate: $rate)
  }
`;

export const deleteTargetRate = gql`
  mutation DeleteTargetRate($targetRateId: ID!) {
    deleteTargetRate(target_rate_id: $targetRateId)
  }
`;
